import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { AppState } from "@app/reducers";
import { CrudService, fileUrlDownload, IApplicationResponse, ModulesBasedApiSuffix, RxjsService, setRequiredValidator, SnackbarService } from "@app/shared";
import { DealerAvsDocumentDetailModel, DealerModuleApiSuffixModels } from "@modules/dealer";
import { loggedInUserData } from "@modules/others";
import { UserLogin } from "@modules/others/models";
import { select, Store } from "@ngrx/store";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/api";


@Component({
  selector: 'app-dealer-avs-check',
  templateUrl: './dealer-avs-check-component.html',
  styleUrls: ['../dealer-documents-add-edit/dealer-documents-add-edit.component.scss']
})
export class DealerAVSCheckComponent implements OnInit {

  loggedUser: any;
  tableRec = "<table class='fidelity-table table-bordered table-responsive'><thead><th colspan='2'>AVS Account Verification</th></thead><tbody><tr><td>Verified</td><td>-</td></tr><tr><td>Verified Dated</td><td>-</td></tr><tr><td>Branch Code</td><td>-</td></tr><tr><td>Account Found</td><td>-</td></tr><tr><td>ID Match</td><td>-</td></tr><tr><td>Surname Match</td><td>-</td></tr><tr><td>Account Open</td><td>-</td></tr><tr><td>Account Dormant</td><td>-</td></tr><tr><td>AccountOpen 3Months</td><td>-</td></tr><tr><td>Account Accepts Debits</td><td>-</td></tr><tr><td>Account Accepts Credits</td><td>-</td></tr><tr><td>Error Reason</td><td>Response Received: Failure, ErrorCode: R0109-,NO MATCH FOUND ON OUR DATABASE The id, name/surname combination does not match our home affairs verified data   </td></tr><tr><td></td><td></td></tr><tr><td><b>Legends</b></td><td></td></tr><tr><td><b>Y - Yes</b></td><td>The bank confirms that the field value is true</td></tr><tr><td><b>N - No</b></td><td>The bank confirms that the field value is false</td></tr><tr><td><b>U - Unprocessed</b></td><td>The bank did not process this field</td></tr><tr><td><b>F - Failed</b></td><td>Failed pre-validation</td></tr></tbody></table>";
  avscheckDetails;
  dealerBranchId: string;
  fullName: string;
  dealerAvsDocumentDialogForm: FormGroup;
  isSubmitted: boolean = false;
  fileName: any;
  showDocError: boolean;

  constructor(private store: Store<AppState>, private crudService: CrudService, private formBuilder: FormBuilder,
    public config: DynamicDialogConfig, public ref: DynamicDialogRef, private snackbarService: SnackbarService,
    private rxjsService: RxjsService) {
    this.store.pipe(select(loggedInUserData)).subscribe((userData: UserLogin) => {
      if (!userData) return;
      this.loggedUser = userData;
    });
  }

  ngOnInit(): void {
    this.dealerBranchId = this.config.data.row.dealerBranchId;
    this.initForm();
    this.getCrdeitVettingAVSCheck();
  }

  initForm(dealerAvsDocumentDetailModel?: DealerAvsDocumentDetailModel) {
    let DealerDocumentModel = new DealerAvsDocumentDetailModel(dealerAvsDocumentDetailModel);
    this.dealerAvsDocumentDialogForm = this.formBuilder.group({});
    Object.keys(DealerDocumentModel).forEach((key) => {
      this.dealerAvsDocumentDialogForm.addControl(key, new FormControl(this.config?.data?.row ? this.config?.data?.row[key] : DealerDocumentModel[key]));
    });
    this.dealerAvsDocumentDialogForm = setRequiredValidator(this.dealerAvsDocumentDialogForm, ["fileName"]);
  }

  getCrdeitVettingAVSCheck() {
    this.crudService.get(ModulesBasedApiSuffix.DEALER, DealerModuleApiSuffixModels.CREDIT_VETTING_AVS_CHECK, this.dealerBranchId, false,
      null)
      .subscribe((response: IApplicationResponse) => {
        if (response.statusCode == 200) {
          this.avscheckDetails = response.resources;
          this.fullName = this.avscheckDetails ? this.avscheckDetails?.firstName + ' ' + this.avscheckDetails?.lastName : '';
        }
        this.rxjsService.setGlobalLoaderProperty(false);

      });
  }

  onOpenDocument() {
    if (this.avscheckDetails?.fileName) {
      fileUrlDownload(this.avscheckDetails?.documentUrl, this.avscheckDetails?.fileName, false, this.crudService, this.rxjsService);
    }
  }

  btnCloseClick() {
    this.ref.close(false);
  }

  onFileSelected(file) {
    this.dealerAvsDocumentDialogForm.get('fileName').markAsDirty();
    if (file?.length) {
      const fileObj = file.item(0);
      const fileType = fileObj.type;
      const fileExtension = fileObj.name.split('.').pop().toLowerCase();
      if (fileType.includes('video/')) {
        return this.snackbarService.openSnackbar("Please do not upload video files");
      }
      const forbiddenExtensions = ['apk', 'ipa'];
      if (forbiddenExtensions.includes(fileExtension)) {
        return this.snackbarService.openSnackbar("APK and iOS files are not allowed.");
      }
      var fileSize = fileObj?.size; // size in bytes
      var maxSize = 10 * 1024 * 1024; // 10MB in bytes
      if (fileSize > maxSize) {
        return this.snackbarService.openSnackbar(`File size exceeds the allowed limit of 10MB.`);
      }
      this.showDocError = false;
      const fileName = fileObj.name;
      // if (fileExtension !== '.xlsx') {
      // this.snackbarService.openSnackbar("Please select .xlsx file extension only", ResponseMessageTypes.WARNING);
      //  return;
      // }
      if (fileName) {
        this.dealerAvsDocumentDialogForm.get('fileName').setValue(fileName);
      }
      this.fileName = fileObj;
    } else if (!this.dealerAvsDocumentDialogForm.get('fileName').value) {
      this.showDocError = true;
    }
  }

  onSubmitDialog() {
    if (this.isSubmitted || !this.dealerAvsDocumentDialogForm?.valid) {
      this.dealerAvsDocumentDialogForm?.markAllAsTouched();
      return;
    } else if (!this.dealerAvsDocumentDialogForm.dirty) {
      this.snackbarService.openSnackbar("No Changes were detected");
      return;
    } else if (!this.dealerAvsDocumentDialogForm.getRawValue()?.fileName) {
      this.snackbarService.openSnackbar("Please upload any file");
      return;
    }
    const obj = this.dealerAvsDocumentDialogForm.getRawValue();
    let formData = new FormData();
    formData.append("file", this.fileName);
    formData.append('Obj', JSON.stringify(obj));
    this.rxjsService.setDialogOpenProperty(true);
    this.rxjsService.setFormChangeDetectionProperty(true); // Form submitt No changes snackbar prevent
    this.isSubmitted = true;
    this.crudService.create(ModulesBasedApiSuffix.DEALER, DealerModuleApiSuffixModels.DEALER_CREDIT_VETTING_DOCUMENT, formData)
      .subscribe((res: IApplicationResponse) => {
        if (res?.isSuccess == true && res?.statusCode == 200) {
          this.dealerAvsDocumentDialogForm.reset();
          this.ref.close(res);
        }
        this.rxjsService.setDialogOpenProperty(false);
        this.isSubmitted = false;
      })
  }
}